
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component
export default class ColoredWidget extends Vue {
  @Prop({ required: true }) color!: string;

  @Prop({ required: true }) title!: string;

  @Prop({ default: undefined }) href!: string | undefined;

  @Prop({ default: undefined }) target!: string | undefined;

  @Prop({ type: Object, default: () => undefined }) to!: Route | undefined;

  @Prop({ default: '' }) svgImage!: string;
}
